
<template>
  <div class="list-content">
    <div class="list-head">
        <div class="list-search">
           <van-search
            v-model="value"
            placeholder="请输入场景关键词"
            @cancel="onCancel"
            @search="onSearch"
          />
        </div>
        <div class="list-banner">
          <van-image
            lazy-load
            :src="banner" rel="external nofollow"
          />
        </div>
    </div>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          :immediate-check="false"
          :offset="8"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <van-cell v-for="(item,index) in list" :key="index" >
            <div class="list-li" @click="onVoice(item)">
                <div class="list-left">
                    <van-image
                      lazy-load
                      :src="item.cover" rel="external nofollow"
                    />
                </div>
                <div class="list-right">
                  <p class="r-title">{{item.scenes_name}}</p>
                  <div class="r-tip">
                    <label v-for="(label,index) in item.label_names" :key="index">
                      <span>
                        {{label}}
                      </span>
                    </label>
                  </div>
                  <p class="r-time">
                    <img src="../../assets/images/clock.svg">
                    距离结束还有<span>{{item.scenes_day}}</span>天
                  </p>
                </div>
            </div>
          </van-cell>
        </van-list>
    </van-pull-refresh>
    <Tabbar :active="0"></Tabbar>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import Tabbar from "@/components/Tabbar";
export default {
  components: { Tabbar },
  data() {
    return {
      banner: require('@/assets/images/scene_banner.png'),
      value:'',
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      page:1,
      pageSize:8,
      scenes_name:'',
      scenes_type:'',
      total:'',
      offset:100,
    };
  },
  computed: {
    ...mapState({ token: "token" }),
  },
  created () {
    this.getPageData();
  },
  methods: {
    ...mapActions({
        newgetList: "newgetList", // 获取对练列表
    }),
    getPageData(){
        let _this = this;
        _this.newgetList({query:
        {
          token:_this.token,
          page:_this.page,
          scenes_name:_this.value
        }
        }).then((res) =>{
          _this.total = res.total;
          if(res.list.length === 0){
             _this.finished = true;
             return;
          }
          if(res.list.length < _this.pageSize){
             _this.finished = true;
          }else{
            _this.finished = false;
          }
          if(_this.page == 1){
            _this.list = res.list;
          }else{
            _this.list = _this.list.concat(res.list);
          }
        }).catch(err => {
          _this.$toast.fail(err.msg)
        }).finally(()=>{
          _this.loading = false;
          _this.refreshing = false;
        });
    },
    onLoad(){
       let _this = this;
      setTimeout(function(){
        _this.page++;
        _this.getPageData();
      },200)
    },
    onSearch(){
      this.page = 1;
      this.getPageData();
    },
    onCancel(){
      this.value = '';
    },
    onRefresh() {
      this.page = 1;
      this.finished = true;
      this.getPageData();
    },
    onVoice(item){
      localStorage.setItem('item', JSON.stringify(item));
      this.$router.push({
        path: "/iframe",
        query: {},
      });
    }
  }
}
</script>
<style lang="less" scoped>
.list-content{
  padding-bottom: 90px;
}
.list-search{
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99;
    width: 100%;
    height: 88px;
    .van-search{
      padding: 8px 32px;
    }
}
.list-banner{
  height: 300px;
  margin-top: 88px;
  .van-image{
    width: 100%;
    height: 100%;
  }
}
/deep/ .van-pull-refresh{
  background-color: #f8f8f8;
}
/deep/ .van-list{
    background-color: #f8f8f8;
    .van-cell{
      padding: 20px 0 20px 32px;
      height: 200px;
      margin-top: 20px;
      .list-li{
        display: flex;
        height: 100%;
        width: 100%;
        .list-left{
          width: 232px;
          height: 160px;
          .van-image{
            width: 100%;
            height: 100%;
            .van-image__img{
              object-fit:cover
            }
          }
        }
        .list-right{
            width: 420px;
            margin-left: 16px;
            .r-title{
              height: 48px;
              line-height: 48px;
              color: #000000;
              font-size: 32px;
              font-weight: 500;
              white-space:nowrap;
              overflow:hidden;
              text-overflow:ellipsis;
              margin-bottom: 12px;
            }
            .r-tip{
              font-size: 0;
              height: 36px;
              line-height: 36px;
                  label{
                    display: inline-block;
                    font-size: 14px;
                    color: #16BAA8;
                    text-align: center;
                    max-width: 134px;
                    height: 36px;
                    line-height: 36px;
                    border: 1px solid #16BAA8;
                    background: #ffffff;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    margin-right: 8px;
                    text-align: center;
                    padding: 0 5px;
                  }
                  label:last-child{
                    margin-right: 0;
                  }
            }
            .r-time{
              margin-top: 20px;
              height: 42px;
              line-height: 42px;
              img{
                width: 28px;
                height: 28px;
                position: relative;
                top:3px;
              }
              span{
                color: #ff7b73;
                display: inline-block;
                margin: 0 4px;
              }
            }
        }
      }
    }
    .van-cell::after{
      border-bottom:none;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/voice/list.vue